import './resources.css';
const Resources = () => {
    return(
        <div className="resources-page">
            <style>
                @import url('https://fonts.googleapis.com/css2?family=Bellota+Text:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&family=DM+Serif+Text:ital@0;1&family=MonteCarlo&display=swap');
            </style>
            <div className="resources-container">
                <div className="license body">
                    <div className="body-title">
                        <h1><b>Marriage License Requirements</b></h1>
                    </div>
                    <div className="body-text">
                        <h3>Please note:  This does not represent all of the counties that we service.</h3>
                        <h2>Indiana</h2>
                        <a className="body-link" href="https://allencoclerk.us/marriage-licenses/marriage-info/">Allen County</a>
                        <a className="body-link" href="https://clerk.elkhartcounty.com/en/courts/about-courts/marriage-licenses/">Elkhart County</a>
                        <a className="body-link" href="https://laporteco.in.gov/courts-services/marriage-license-requirements/">LaPorte County</a>
                        <a className="body-link" href="http://www.porterco.org/147/Marriage-Licenses">Porter County</a>
                        <a className="body-link" href="https://www.sjcindiana.com/195/Marriage-License-Application">St. Joseph County</a>
                        <br/>
                        <h2>Michigan</h2>
                        <a className="body-link" href="https://www.calhouncountymi.gov/departments/clerk_and_register_of_deeds/marriage_license.php">Calhoun County</a>
                        <a className="body-link" href="https://www.kalcounty.gov/436/Apply-for-a-Marriage-License">Kalamazoo County</a>
                    </div>
                </div>
                <div className="vendor body">
                    <div className="body-title">
                        <h1><b>Recommended Wedding Vendors</b></h1>
                    </div>
                    <div className="body-text">
                        <h3>I have had the great honor to work with the following vendors and am happy to recommend and support their work!</h3>
                        <h2>Photographers I love to work with</h2>
                        <a className="body-link" href="https://www.taylorrayephoto.com/">Taylor Raye Photography</a>
                        <a className="body-link" href="https://livvincentphotography.com/">Liv Vincent Photography</a>
                        <a className="body-link" href="http://www.mattandjaymi.com/">Matt and Jaymi</a>
                        <a className="body-link" href="https://brandedphotographyllc.com/">Branded Photography</a>
                        <a className="body-link" href="http://www.bgravesphotography.com/">B Graves Photography</a>
                        <br/>
                        <h2>Wedding DJs that are truly amazing</h2>
                        <a className="body-link" href="https://djdocaustin.com/">DJ Doc Austin</a>
                        <a className="body-link" href="https://www.aceweddingdjs.com/">Ace Wedding DJs</a>
                        <a className="body-link" href="https://www.27.events/">27 Entertainment</a>
                        <a className="body-link" href="http://fourofakindent.com/">Four of a Kind Entertainment</a>
                        <a className="body-link" href="https://www.idocrewdjs.com/weddings">I Do Crew DJ</a>
                    </div>
                </div>
            </div>
        </div>
	);
}

export default Resources;